import React from "react";
import { Modal } from "react-bootstrap";
import { FiX } from "react-icons/fi";

function Exco1({ show, onClose, onOpen }) {
  return (
    <div>
      <div>
        <Modal
          size="lg"
          show={show}
          onHide={onClose}
          // backdrop="static"
          aria-labelledby="example-modal-sizes-title-lg"
          keyboard={false}
          animation={true}
          centered
        >
          <Modal.Body>
            <div className="Solera__Cont">
              <FiX className="Solera__Close" onClick={onClose} />
            </div>

            <div className="Exoc-Name">Dr Oluwole Adeniyan</div>
            <div className="Exco-Tittle">General Secretary</div>
            <br />

            <div className="Excos-Bio">
              Dr Oluwole Adeniyan completed his dental surgery degree from the
              University of Lagos but has other numerous qualifications
              afterward. This includes MBChB (Birmingham), M.Sc (Aberdeen), MFDS
              RCPS (Glasgow), and MRCGP(UK). <br /> <br />
              Olu is a General Medical Practitioner with a special interest in
              community-based surgical procedures, amongst other roles. He is
              also a community vasectomy surgeon. <br /> <br />
              Dr Adeniyan is the secretary of the UNILAG Alumni UK and has been
              an active member since its inception. <br /> <br />
              Olu is a football enthusiast and a supporter of Liverpool FC. He
              is a member of the ASPC (Association of Surgeons in Primary Care),
              and he is the District Representative for South Staffordshire
              Royal College of General Practitioner (RCGP).
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default Exco1;
